import axios from "axios";

const putAppointmentCancel = async (baseUrl, token, patientId, appointmentId) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + `/patient/` + patientId + "/appointment/" + appointmentId + "/cancel", {}, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    result: error.response.status
                }
            }
        });
    return putResponse
}

export default putAppointmentCancel;